import React, {forwardRef, useRef, useImperativeHandle, useState, useEffect, useCallback} from 'react';
import { CircularProgress, Dialog, Button,DialogTitle } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import {useDropzone} from 'react-dropzone';
// Actions
import {uploadMedia} from '../../../actions/Data/Datasets';
import makeStyles from '@material-ui/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root:{        
        width:'300px',
        display:'flex',
        flexDirection:'column',
        // alignItems:'center',
        // padding:'1em',
    },
    dropzone:{
        textAlign:'center',
        display:'flex',  
        alignItems:'center',
        flexDirection:'column',
        justifyContent:'space-around',
        border:'2px dashed',
        height:'100px',
        transition: 'border .24s ease-in-out',
        borderWidth: 2,
        borderRadius: 2,
    },
    imgPreview:{
        objectFit: 'contain',
        maxWidth:'300px',
    },
    buttonCont:{
        display:'flex',  
        justifyContent:'space-between',
    }
}));



const ImageEditor = (props,ref)=>{
    console.log(props.type);//media
    const refFileInput = useRef();
    const refA = useRef();
    const refImgPreview = useRef();
    const classes = useStyles();
    const [isUploading,setIsUploading] = useState(false);
    const [imgPreviewUrl,setImgPreviewUrl] = useState('https://gea2.myglobe.app/uploads/gea/media/'+props.value);
    const isMediaLoading = useSelector(state => state.Data.loading.media);
    const error = useSelector(state => state.Data.uploads.error);
    const filename = useSelector(state => state.Data.uploads.name);
    const [file,setFile] = useState(null);
    const dispatch = useDispatch();
    const onDrop = useCallback(acceptedFiles => {                
        setImgPreviewUrl(window.URL.createObjectURL(acceptedFiles[0]));
        setFile(acceptedFiles[0]);
    });      
    const {getRootProps, getInputProps, isDragActive, inputRef, open} = useDropzone({accept: 'image/*',onDrop,noClick:true});
    
    const uploadFile = useCallback(()=>{
        console.log(inputRef, file);
        if(file) {
            setIsUploading(true);
            dispatch(uploadMedia(file));            
        }
    });
    const cancel = useCallback(()=>{
        props.onCommit && props.onCommit();
    });

    useEffect(()=>{
        if(isUploading && !isMediaLoading && error){
            setIsUploading(false);
        } else if(isUploading && !isMediaLoading && filename) {
            setIsUploading(false);            
            handleUpdate();
            props.onCommit && props.onCommit();
        }
    },[isMediaLoading, error, filename, isUploading, props]);

    useImperativeHandle(ref, () => ({
        getInputNode() {
            return inputRef.current;
        },
        getValue() {
            if(filename && !error && !isMediaLoading)            
                return {[props.column.key]:filename};
            else
                return {[props.column.key]:props.value};
        },
        isSelectOpen() {
            return false;
        }
    }), [inputRef, filename, error, isMediaLoading, props.column.key, props.value]);

    const handleUpdate = () => {
        if(props.onUpdate && filename && !error && !isMediaLoading)            
            return filename;
        else
            return props.value;
    };

    return( 
        <Dialog open={true}>        
            <DialogTitle id="simple-dialog-title">Upload new image</DialogTitle>
            <div className={classes.root}>
                {error&&<div>Error: {error}</div>}
                {isUploading&&<div><CircularProgress /><br />uploading</div>}
                {!isUploading&& 
                <>
                    <img ref={refImgPreview} className={classes.imgPreview} src={imgPreviewUrl} />
                    <div className={classes.dropzone} ref={refFileInput} {...getRootProps()}>                               
                        {isDragActive ?
                            <p>Drop the files here ...</p> :
                            <p>Drag 'n' drop files here</p>}
                        <p>OR</p>
                        <input {...getInputProps({accept:'image/*',multiple:false,style:{maxWidth:'82px',display:'inline!important;'}})} />                    
                    </div>
                    <div className={classes.buttonCont}>
                        <Button onClick={uploadFile} disabled={file==null} variant="outlined" color="primary">UPLOAD</Button>
                        <Button onClick={cancel} color="secondary">CANCEL</Button>
                    </div>
                </>}
            </div>        
        </Dialog>       
    );
};

export default forwardRef(ImageEditor);